export const APP_ENV = process.env.REACT_APP_ENV;
export const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL;
export const PHPSESSID = process.env.REACT_APP_PHPSESSID;
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const NEWRELIC_ENABLED = process.env.REACT_APP_NEWRELIC_ENABLED;
export const NEWRELIC_LICENSE_KEY = process.env.REACT_APP_NEWRELIC_LICENSE_KEY;
export const NEWRELIC_APPLICATION_ID = process.env.REACT_APP_NEWRELIC_APPLICATION_ID;
export const NEWRELIC_ACCOUNT_ID = process.env.REACT_APP_NEWRELIC_ACCOUNT_ID;
export const LLM_BASE_URL = process.env.REACT_APP_LLM_BASE_URL;
export const BUGSNAG_API_KEY = process.env.REACT_APP_BUGSNAG_API_KEY;
